import React from 'react'
import styles from './ColumnLabel.module.scss'
import { Props } from './types'
import {
  Draggable,
  DraggableProvided,
  DraggableStateSnapshot
} from 'react-beautiful-dnd'
import { IconDragIndicator } from 'assets'
import cl from 'classnames'
import { getDirectionSymbol } from 'utilities'

function ColumnLabelComponent<TabType> (props: Props<TabType>) {
  const {
    column: {
      icon: Icon,
      label,
      width,
      draggable = false,
      sortable,
      sortDirection,
      toggleSortDirection,
      style = {}
    },
    index
  } = props

  const handleClick = () => {
    sortable && toggleSortDirection()
  }

  return (
    <Draggable
      key={index}
      draggableId={label as unknown as string}
      index={index}
      isDragDisabled={!draggable}
    >
      {(provided: DraggableProvided,
        snapshot: DraggableStateSnapshot) => {
        return (
          <div
            ref={provided.innerRef}
            {...provided.draggableProps}
            id={label as unknown as string}
            className={cl(styles.headerCol, {
              [styles.dragging]: snapshot.isDragging,
              [styles.clickable]: sortable
            })}
            style={{
              ...provided.draggableProps.style,
              ...style,
              width
            }}
            onClick={handleClick}
          >
            <Icon fill={styles.borderGrey} opacity='0.6' />
            <span>{label}</span>
            {sortable &&
              <span className={styles.symbol}>{getDirectionSymbol(sortDirection)}</span>
            }
            {draggable &&
              <span
                style={{ marginLeft: 'auto', padding: 10 }}
                {...provided.dragHandleProps}
              >
                <IconDragIndicator />
              </span>
            }
          </div>
        )
      }}
    </Draggable>
  )
}

const ColumnLabel = ColumnLabelComponent
export { ColumnLabel }
